import { useApi } from '@api/ApiProvider'
import { useI18n } from '@i18n/I18nProvider'
import { ConditionBadge } from '@ui/ConditionBadge'
import { Icon } from '@ui/Icon'
import { ErrorState, LoadingState } from '@ui/States'
import { Link } from 'wouter'
import { ConditionFilter } from './ConditionFilter'
import { usePanelFilters } from './filters'
import { Pager } from './Pager'
import { usePanelQuery } from './StaffSession'
import { useNames } from './useNames'

export const PAGE_SIZE = 20

// Pestaña "Árboles": los publicados con su último estado, filtrables por estado y ordenados por
// la antigüedad del último aviso (spec `monitoring`). Cada uno abre su historial.
export const TreesPage = () => {
	const { t } = useI18n()
	const api = useApi()
	const names = useNames()
	const { condition, page, setCondition, setPage } = usePanelFilters()
	const trees = usePanelQuery(['trees', condition ?? 'all', page], (token) =>
		api.treesByCondition(token, { condition, page, limit: PAGE_SIZE })
	)

	return (
		<>
			<ConditionFilter value={condition} onChange={setCondition} />
			{trees.isPending ? (
				<LoadingState shape="list" />
			) : !trees.data ? (
				<ErrorState error={trees.error} onRetry={() => trees.refetch()} />
			) : trees.data.items.length === 0 ? (
				<p className="py-8 text-center text-lg text-earth-800">{t('trees.empty')}</p>
			) : (
				<>
					<p className="mb-3 text-earth-800">{t('trees.count', { count: trees.data.meta.total })}</p>
					<ul className="grid gap-3">
						{trees.data.items.map((tree) => (
							<li key={tree.code}>
								<Link
									href={`/arboles/${encodeURIComponent(tree.code)}`}
									className="flex items-center gap-3 rounded-3xl bg-white p-4 shadow-sm active:bg-earth-100"
								>
									<span className="min-w-0 flex-1">
										<span className="block text-lg font-bold text-forest-800">
											{t('tree.code', { code: tree.code })}
										</span>
										<span className="mb-2 block text-earth-800">
											{names.species(tree.speciesId)} · {names.municipality(tree.municipalityId)}
										</span>
										<ConditionBadge
											latest={
												tree.condition && tree.reportedAt
													? { condition: tree.condition, reportedAt: tree.reportedAt }
													: null
											}
										/>
									</span>
									<Icon name="forward" className="size-6 shrink-0 text-earth-600" />
								</Link>
							</li>
						))}
					</ul>
					<Pager meta={trees.data.meta} onChange={setPage} />
				</>
			)}
		</>
	)
}
